import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { FaCircle } from "react-icons/fa";
import { BACKEND_SERVER_URL } from '../../http/http-config';



const ErrorTest = () => {
    //set Table data
    const [credentials, setCredentials] = useState([]);
    const [changed, setChanged] = useState(false);
    const [status, setStatus] = useState('');
    const [load, setLoad] = useState(false);
    // console.log("credentials", credentials);
    // console.log("changed", userType);

    useEffect(() => {
        async function TestingData() {
            const response = await axios.get(`${BACKEND_SERVER_URL}/ErrorTest`);
            setCredentials(response.data.data);
            setStatus(response.data.data[0].Status);
            setChanged(response.data.credentialsChanged);
        }
        TestingData()
    }, [load])

    const toggleError = async () => {
        try {
            const response = await axios.post(`${BACKEND_SERVER_URL}/ErrorTestToggle`, { credentials });
            setStatus(response.data.Status);
            setLoad(!load);
        } catch (error) {
            console.error("Error toggling user type:", error);
        }
    }


    return (
        <>
            <div className="row">
                <div className="col-xl-12 p-5">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className=' col-sm-6 d-flex justify-content-start'>
                                        <button type="button" className={`btn ${status == 'ACTIVE' ? 'btn-success' : 'btn-danger'} btn-sm me-2 w-25`}
                                            onClick={() => toggleError()}
                                        >
                                            {status}
                                        </button>

                                    </div>
                                    <div className='col-sm-6 d-flex justify-content-end'>
                                        <h4>Credential Changed : {changed ? 'Yes' : 'No'}</h4>
                                    </div>

                                </div>
                            </div>
                            {/* <ProdutsDetailsTabsAtTop setChecked={setChecked} totalItems={examBodies} totalActiveItems={totalActiveExamBodies} totalInactiveItems={totalInactiveExamBodies} totalArchivedItems={totalArchivedExamBodies} /> */}
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">

                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className=' custom-table-header  p-2'>SN</th>
                                                <th className=' text-start custom-table-header  p-2' >Email</th>
                                                {/* <th className=' text-start custom-table-header  p-2' >Usertype</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {credentials?.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="sn-font-weight mb-0"> {item.Sn}</h6></td>

                                                    {/* <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.examBody}{item.currentYear && <FaCircle className='ms-1' style={{ marginTop: "0px", paddingTop: "0px" }} color='green' size={7} />} {' '}</h6>
                                                        </div>
                                                    </td> */}

                                                    <td className='text-start p-1' style={{ border: "1px solid #cccccc", width: "65px" }}><h6 className="mb-0">{item.EmailId}</h6></td>
                                                    {/* <td className='text-start p-1' style={{ border: "1px solid #cccccc", width: "65px" }}><h6 className="mb-0">{item.UserType}</h6></td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ErrorTest;
